import { Outlet } from "react-router-dom";
import { Automations } from "./Automations";
import AutomationConstructor from "./AutomationConstructor/AutomationConstructor";

export const adminAutomationsRoutes = [
  {
    path: "automations",
    element: Outlet,
    children: [
      {
        path: "",
        element: Automations,
      },
      {
        path: "create/constructor/:automationID",
        element: AutomationConstructor,
      },
    ],
  },
];
